var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { GoogleIntegrationReauthBanner } from '@web/components/layout/GoogleIntegrationReauthBanner';
import Footer from '@web/pages/layout/Footer';
import Header from '@web/pages/layout/Header';
import React from 'react';
export var Page = function (_a) {
    var children = _a.children;
    return (_jsxs(_Fragment, { children: [_jsx(GoogleIntegrationReauthBanner, {}), _jsx(Header, {}), _jsxs("div", __assign({ className: "mx-auto mt-8 max-w-7xl px-6 sm:mt-6 lg:px-8" }, { children: [children, _jsx(Footer, {})] }))] }));
};
